export default __webpack_public_path__ + "c3e2ffb17da8e5209ae03ed52ed600e7.svg";